import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const SpecialSystemDocumentGuard = createFeatureGuard(Feature.ConstructionDocument);